/**
 * Halaman Syarat & Ketentuan dan Kebijakan Privasi.
 *
 * CATATAN: isi di bawah adalah draf umum untuk toko produk digital, bukan
 * nasihat hukum. Tinjau dan sesuaikan dengan praktik bisnis Anda yang
 * sebenarnya sebelum dipakai serius — terutama bagian refund dan garansi.
 */

interface Section {
  heading: string;
  body: string[];
}

const TERMS: Section[] = [
  {
    heading: "Tentang layanan ini",
    body: [
      "AG5R.STORE menjual produk digital berupa kode lisensi, akun siap pakai, dan tautan unduh. Semua produk dikirim otomatis ke halaman Akun Saya setelah pembayaran terkonfirmasi.",
      "Dengan melakukan pembelian, Anda dianggap telah membaca dan menyetujui ketentuan di halaman ini.",
    ],
  },
  {
    heading: "Akun pembeli",
    body: [
      "Pembelian memerlukan login menggunakan akun Google. Anda bertanggung jawab menjaga keamanan akun tersebut.",
      "Produk yang sudah dibeli terikat pada akun yang dipakai saat transaksi dan tidak dapat dipindahkan ke akun lain.",
    ],
  },
  {
    heading: "Pembayaran",
    body: [
      "Harga ditampilkan dalam Rupiah dan sudah final — tidak ada biaya tambahan yang disembunyikan.",
      "Pembayaran diproses oleh penyedia pihak ketiga. Pesanan yang belum dibayar akan kedaluwarsa otomatis dan stoknya dilepas kembali.",
    ],
  },
  {
    heading: "Pengiriman produk",
    body: [
      "Produk terbit otomatis begitu pembayaran dikonfirmasi oleh penyedia pembayaran, umumnya dalam hitungan detik.",
      "Jika pembayaran Anda sudah terpotong tetapi produk belum muncul di halaman Akun Saya, hubungi kami dengan menyertakan nomor pesanan.",
    ],
  },
  {
    heading: "Pengembalian dana",
    body: [
      "Karena sifatnya digital dan langsung terkirim, produk yang sudah dibuka atau diaktifkan pada dasarnya tidak dapat dikembalikan.",
      "Pengembalian dana dipertimbangkan apabila produk terbukti tidak berfungsi sejak awal dan tidak dapat kami gantikan.",
    ],
  },
  {
    heading: "Penggunaan yang dilarang",
    body: [
      "Dilarang menjual kembali, membagikan, atau menggandakan produk yang Anda beli tanpa izin tertulis.",
      "Pelanggaran dapat berakibat penonaktifan akun tanpa pengembalian dana.",
    ],
  },
];

const PRIVACY: Section[] = [
  {
    heading: "Data yang kami kumpulkan",
    body: [
      "Saat Anda masuk dengan Google, kami menerima alamat email dan pengenal akun Anda. Kami tidak menerima kata sandi Google Anda.",
      "Kami juga menyimpan riwayat pesanan dan produk yang terbit untuk akun Anda.",
    ],
  },
  {
    heading: "Data pembayaran",
    body: [
      "Kami TIDAK menyimpan nomor kartu, saldo e-wallet, maupun kredensial perbankan Anda.",
      "Seluruh proses pembayaran ditangani penyedia pembayaran pihak ketiga. Kami hanya menerima status transaksi dan metode pembayaran yang dipakai.",
    ],
  },
  {
    heading: "Penggunaan data",
    body: [
      "Data Anda dipakai untuk menerbitkan produk, menampilkan riwayat pembelian, dan menangani keluhan.",
      "Kami tidak menjual maupun menyewakan data Anda kepada pihak lain.",
    ],
  },
  {
    heading: "Penyimpanan dan keamanan",
    body: [
      "Data disimpan pada infrastruktur terenkripsi dengan akses terbatas.",
      "Kredensial produk hanya ditampilkan kepada pemilik akun yang membelinya.",
    ],
  },
  {
    heading: "Hak Anda",
    body: [
      "Anda berhak meminta salinan atau penghapusan data pribadi Anda.",
      "Perlu diketahui, penghapusan akun juga menghapus akses ke seluruh produk yang pernah Anda beli.",
    ],
  },
];

export function LegalPage({ kind }: { kind: "terms" | "privacy" }) {
  const isTerms = kind === "terms";
  const sections = isTerms ? TERMS : PRIVACY;
  const title = isTerms ? "Syarat & Ketentuan" : "Kebijakan Privasi";

  return (
    <div className="max-w-3xl mx-auto px-4 py-16">
      <h1 className="font-heading text-4xl font-extrabold tracking-tight text-ink-primary">
        {title}
      </h1>
      <p className="mt-3 font-sans text-sm text-ink-dim">
        Terakhir diperbarui:{" "}
        {new Date().toLocaleDateString("id-ID", { year: "numeric", month: "long" })}
      </p>

      <div className="mt-10 space-y-9">
        {sections.map((s) => (
          <section key={s.heading}>
            <h2 className="font-heading text-xl font-bold text-ink-primary">{s.heading}</h2>
            {s.body.map((p, i) => (
              <p key={i} className="mt-3 font-sans text-sm text-ink-muted leading-relaxed">
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
